import { z } from 'zod';

// Schema base para Learning
export const learningFormSchema = z.object({
  name: z.string()
    .min(1, 'O título é obrigatório')
    .min(3, 'O título deve ter pelo menos 3 caracteres'),
  
  creatorId: z.string()
    .min(1, 'Selecione um criador'),
  
  cover: z.string()
    .min(1, 'Uma imagem de capa é obrigatória'),
  
  type: z.enum(['ARTICLE', 'VIDEO', 'COURSE', 'TUTORIAL']),
  
  coverType: z.enum(['IMAGE', 'VIDEO']),
  
  published: z.boolean(),
  
  categoryLearning: z.string()
    .min(1, 'Uma categoria é obrigatória'),
  
  contents: z.array(z.object({
    type: z.string(),
    subType: z.string(),
    value: z.string().min(1, 'O conteúdo não pode estar vazio'),
    order: z.number(),
    published: z.boolean()
  })).min(1, 'Adicione pelo menos um conteúdo')
});

// Schema para Preset
export const presetFormSchema = z.object({
  name: z.string()
    .min(1, 'O nome é obrigatório')
    .min(3, 'O nome deve ter pelo menos 3 caracteres'),
  
  description: z.string()
    .min(1, 'A descrição é obrigatória'),
  
  tags: z.string()
    .min(1, 'As tags são obrigatórias'),
  
  cover: z.string()
    .min(1, 'Uma imagem de capa é obrigatória'),
  
  lutFile: z.string()
    .min(1, 'Um arquivo LUT é obrigatório'),
  
  published: z.boolean(),
  
  isFree: z.boolean()
});

// Schema para Pack
export const packFormSchema = z.object({
  name: z.string()
    .min(1, 'O nome é obrigatório')
    .min(3, 'O nome deve ter pelo menos 3 caracteres'),
  
  description: z.string().optional(),
  
  translations: z.array(z.object({
    languageCode: z.string(),
    description: z.string(),
  })).refine(
    (arr) => arr.some((t) => t.description?.trim()),
    { message: 'A descrição em pelo menos um idioma é obrigatória' }
  ),
  
  creator: z.string()
    .min(1, 'O criador é obrigatório'),
  
  cover: z.string()
    .min(1, 'A capa é obrigatória'),
  
  published: z.boolean(),
  
  creators: z.array(z.object({
    id: z.string(),
    percentage: z.number().min(0, 'A porcentagem deve ser maior ou igual 0'),
    displayOrder: z.number()
  })).optional()
  .refine((creators) => {
    if (!creators || creators.length === 0) return true;
    return creators.every((c) => (c.percentage ?? 0) >= 0);
  }, { message: 'As porcentagens devem ser maiores ou iguais a 0%' })
  .refine((creators) => {
    if (!creators || creators.length === 0) return true;
    const total = creators.reduce((sum, c) => sum + (c.percentage ?? 0), 0);
    return total === 100;
  }, { message: 'A soma das porcentagens deve ser 100%' }),
  
  // presets: z.array(z.object({
  //   id: z.string().optional(),
  //   name: z.string().min(1, 'O nome do preset é obrigatório'),
  //   description: z.string().min(1, 'A descrição do preset é obrigatória'),
  //   cover: z.string().min(1, 'A capa do preset é obrigatória'),
  //   lutFile: z.string().min(1, 'O arquivo LUT é obrigatório'),
  //   published: z.boolean(),
  //   isFree: z.boolean()
  // })).optional()
});

// Tipos inferidos dos schemas
export type LearningFormData = z.infer<typeof learningFormSchema>;
export type PresetFormData = z.infer<typeof presetFormSchema>;
export type PackFormData = z.infer<typeof packFormSchema>;
